export function hasCharacters(myString) {
    return myString.match(/[a-z]/i);
}